<template>
  <div class="container">
    <StMobileMenu :is-active="isOpenedMenu">
      <TheMSidebar />
    </StMobileMenu>
    <WebTelegramForbiddenWidget v-if="isTgMiniAppInSafari" />
    <MHeaderPwaWidget v-else-if="isVisiblePwaWidget && !isTelegramMiniApp" />
    <TheMHeader v-bind="props" />
    <main class="main">
      <div class="content">
        <slot />
      </div>
    </main>
    <TheMFooter
      v-if="!withoutFooter"
      :without-footer-menu="withoutFooterMenu"
    />
    <MCoupon v-if="isShownCoupon" />
    <TapBar v-if="!withoutTapbar" :class="{ hidden: !isVisibleTapBar }" />
  </div>
</template>

<script setup lang="ts">
import MCoupon from '@st/coupon/components/Coupon/MCoupon.vue'
import { useTelegram } from '@st/telegram/composables/useTelegram'
import MHeaderPwaWidget from '@st/pwa/components/MHeaderPwaWidget/MHeaderPwaWidget.vue'
import { usePwaWidgetVisibility } from '@st/pwa/composables/usePwaWidgetVisibility'
import TheMHeader from '../TheHeader/TheMHeader.vue'
import TapBar from '../TapBar/TapBar.vue'
import TheMSidebar from '../TheSidebar/TheMSidebar.vue'
import TheMFooter from '../TheFooter/TheMFooter.client.vue'
import { exactlyEquals, startsWith } from '@st/i18n-base/utils'

const props = defineProps<{
  withMenuButton?: boolean
  withSearchButton?: boolean
  withBackButton?: boolean
  withoutFooter?: boolean
  withoutTapbar?: boolean
  withoutFooterMenu?: boolean
  withCloseButton?: boolean
}>()

const { isTgMiniAppInSafari } = useTelegram()
const { isOpenedMenu, isVisibleTapBar } = useMobileLayout()
const { isVisiblePwaWidget } = usePwaWidgetVisibility()
const { isTelegramMiniApp } = useTelegram()

const route = useRoute()
const isShownCoupon = computed(
  () =>
    exactlyEquals(route.path, '/') ||
    startsWith(route.path, '/sport') ||
    startsWith(route.path, '/cybersport'),
)
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}

.main {
  flex-grow: 1;
  min-height: 0;
}

.hidden {
  bottom: -60px;
  transition: 0.25s 0.1s ease-in-out;
}
</style>
